import { Action } from './core/action';

export class LanguageChangeAction implements Action {
  constructor(public language: string, public reloadAuthData: boolean) {}
}



// WEBPACK FOOTER //
// src/app/common/actions/language.action.ts